__webpack_require__.p = "//gift-pmxpu-cdn.didipay.com/static/manhattan_global_static/freya-kyc/landing-page/";